/**
 * Vérifie si un élément n'est pas le fils
 */
export function elementNotChildren(parent, element) {
    let childrens = Array.from(parent.getElementsByTagName("*"));
    if (element != parent && childrens.indexOf(element) == -1) {
        return true;
    }
}